import React from 'react';
import { useContracts } from '../../../hooks/useEntities';
import YearModuleAnalyticsReport from '../components/YearModuleAnalyticsReport';

function contractStatus(r) {
  if (!r?.expiryDate) return 'Active';
  const exp = new Date(r.expiryDate);
  if (Number.isNaN(exp.getTime())) return 'Active';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  exp.setHours(0, 0, 0, 0);
  return exp < today ? 'Expired' : 'Active';
}

const ContractAnalyticsReport = () => (
  <YearModuleAnalyticsReport
    title="Contracts Analytics"
    description="Contracts by start date in the selected year — active vs expired and suppliers."
    useData={useContracts}
    dateField={['startDate', 'createdAt']}
    getStatusLabel={contractStatus}
    getSecondaryLabel={(r) => r?.supplier?.name || r?.category?.name || '—'}
    secondaryTitle="By supplier / category"
    getRowLabel={(r) =>
      r?.contractTitle || r?.contractNumber || (r?.id != null ? `#${r.id}` : '—')
    }
  />
);

export default ContractAnalyticsReport;
